import React, { createContext, useContext, useEffect, useRef, useState, useCallback } from 'react';

const WSCtx = createContext(null);

export function WSProvider({ children }) {
  const wsRef = useRef(null);
  const listenersRef = useRef({});
  const [connected, setConnected] = useState(false);

  const connect = useCallback((token) => {
    if (wsRef.current && wsRef.current.readyState < 2) return;

    const protocol = window.location.protocol === 'https:' ? 'wss' : 'ws';
    const host = window.location.hostname;
    const ws = new WebSocket(`${protocol}://${host}:3001`);
    wsRef.current = ws;

    ws.onopen = () => {
      ws.send(JSON.stringify({ type: 'auth', token }));
    };

    ws.onmessage = (e) => {
      try {
        const msg = JSON.parse(e.data);
        if (msg.type === 'auth_ok') setConnected(true);
        const handlers = listenersRef.current[msg.type] || [];
        handlers.forEach(h => h(msg));
      } catch {}
    };

    ws.onclose = () => {
      setConnected(false);
    };
  }, []);

  const disconnect = useCallback(() => {
    wsRef.current?.close();
    setConnected(false);
  }, []);

  const send = useCallback((payload) => {
    if (wsRef.current?.readyState === WebSocket.OPEN) {
      wsRef.current.send(JSON.stringify(payload));
    }
  }, []);

  const on = useCallback((type, handler) => {
    if (!listenersRef.current[type]) listenersRef.current[type] = [];
    listenersRef.current[type].push(handler);
    return () => {
      listenersRef.current[type] = listenersRef.current[type].filter(h => h !== handler);
    };
  }, []);

  return (
    <WSCtx.Provider value={{ connect, disconnect, send, on, connected }}>
      {children}
    </WSCtx.Provider>
  );
}

export const useWS = () => useContext(WSCtx);
